<script>
  import Header from '../Components/Header.svelte';
  import Diagonale from '../Components/diagonale.svelte';
  import Hero from '../Components/Hero.svelte';
  import RangeSlider from 'svelte-range-slider-pips';
  import { useNavigate } from 'svelte-navigator';
  import SketchfabModel from '../Components/SketchfabModel.svelte';
  const navigate = useNavigate();
  import { alertReload } from '../stores.js';

  $alertReload = false;
</script>

<!-- https://sketchfab.com/developers/viewer -->
<!-- https://help.sketchfab.com/hc/en-us/articles/360040087671-How-do-I-remove-the-Sketchfab-watermark-from-my-embedded-viewer-#Editing_the_embedded_viewer_options -->
<!-- https://help.sketchfab.com/hc/en-us/articles/115005492703-Premium-membership -->
<!-- https://help.sketchfab.com/hc/en-us/articles/203497057-Business -->

<!-- <div id="wrapper-header" class="asResponsiveCenter">
  <Header />
  <Hero />
</div> -->

<!-- <Header /> -->
<Hero />

<section class="as-bg-black relative">
  <div class="as-container mx-auto text-white">
    <!-- <div class="asphone">
      <SketchfabModel uid="cfe43c114ec2450ab926f5a220c5ed7b" />
    </div> -->
    <div class="grid grid-cols-2 gap-4 as-grid">
      <div class="col-left">
        <img
          src="./statics/icons/picto-commander.png"
          alt="Comment commander"
        />
        <div class="titre-faq">Comment obtenir un devis ?</div>
        <div class="titre-sub-faq">
          Vous êtes un client / prospect distributeur ?
        </div>
        <p>
          1. Pour obtenir un devis d’une trappe sur mesure, utilisez le
          configurateur qui vous permettra de personnaliser votre trappe, en
          vous permettant de choisir les différentes options.
          <br />
          2. Votre demande sera transmise à notre service commercial qui vous renverra
          une offre de prix ainsi que le délai de livraison.
          <br />
          3. Vous validez le devis auprès de notre service commercial (votre contact
          habituel)
          <br />
          4. La trappe est mise en fabrication et vous est livrée.
        </p>

        <div class="titre-sub-faq mt-3">
          Vous êtes un particulier / artisan/ applicateur ?
        </div>
        <p style="padding-bottom:50px;">
          1. Pour obtenir un devis d’une trappe sur mesure, utilisez le
          configurateur qui vous permettra de personnaliser votre trappe, en
          vous permettant de choisir les différentes options.
          <br />
          2. Votre demande sera transmise à notre service commercial qui se rapprochera
          de l’un de nos distributeurs partenaires afin de vous remettre l’offre
          de prix et le délai de livraison.
          <br />
          3. Vous validez le devis auprès du distributeur. Ce dernier nous valide
          alors la commande.
          <br />
          4. La trappe est mise en fabrication puis envoyée chez notre partenaire
          distributeur.
          <br />
          5. Vous êtes avertis que la trappe est disponible, vous pouvez aller la
          retirer et procéder au paiement.
        </p>
        <img
          src="./statics/icons/picto-configurateur.png"
          alt="Comment utiliser le configurateur"
        />

        <div class="titre-faq">Comment utiliser le configurateur ?</div>
        <p style="padding-bottom:50px;">
          1. Choisissez tout d’abord quel type de trappe vous souhaitez
          configurer : trappe métallique, trappe alu hydro, trappe vide
          sanitaire, trappe multi-étanchéités, trappe coupe-feu.
          <br />
          2. Vous pouvez ensuite la personnaliser, en choisissant une par une les
          options de votre trappe qui vous sont proposées par SEMIN.
          <br />
          3. Indiquez vos coordonnées
          <br />
          4. Vous serez re-contacter par notre service commercial ou par un de nos
          distributeurs
        </p>
      </div>
      <!-- <div class="asdesk"> -->
      <SketchfabModel uid="cfe43c114ec2450ab926f5a220c5ed7b" />
      <!-- </div> -->
    </div>

    <div class="video-container">
      <iframe 
      src="https://www.youtube.com/embed/lkWq-DV9Liw?si=xE_t7_1wi5fS26Ck&modestbranding=1&rel=0" 
      title="YouTube video player" 
      frameborder="0" 
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
      referrerpolicy="strict-origin-when-cross-origin" 
      allowfullscreen
      ></iframe>
    </div>
    

  </div>
</section>



<style>
  .video-container {
    position: relative;
    width: 100%;
    padding-top: 56.25%; /* 16:9 Aspect Ratio */
    overflow: hidden;
  }

  .video-container iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
  .col-left {
    padding-right: 15px;
  }
  .as-bg-black {
    margin-top: 60px;
    padding: 60px 0;
    background-color: #000;
  }
  .titre-faq {
    font-family: 'introblack';
    font-size: 35px;
    line-height: 40px;
    padding: 10px 0;
  }
  .titre-sub-faq {
    font-family: 'introblack';
    font-size: 24px;
    line-height: 40px;
    padding: 10px 0;
  }
  @media only screen and (max-width: 768px) {
    .as-bg-black {
      margin-top: 30px;
      padding: 30px 0;
    }
    .as-container {
      padding: 0 20px;
    }
    .as-grid {
      grid-template-columns: none;
    }
  }
</style>
